import { render, staticRenderFns } from "./site-message.vue?vue&type=template&id=20d88f6c&"
import script from "./site-message.vue?vue&type=script&lang=js&"
export * from "./site-message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports